import _ from "lodash";
import React, { createRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import NextArrow from "../../LearningPaths/NextArrow";
import PrevArrow from "../../LearningPaths/PrevArrow";
import Pagination from "../../../pages/Orders/Pagination";
import exportFromJSON from "export-from-json";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import PieChart from "../../Layouts/Graphs/PieChart";
import ReportGraphSection from "../ReportGraphSection";
import { SessionKeys } from "../../../utils/AppUtils";

import moment from "moment";
import PaginationProgress from "../progressReport/PaginationProgress";
import CONFIG from "../../../utils/config";
import axios from "axios";
import SimplePopup from "../../modal/SimplePopup";
import API_LIST from "../../../utils/apiList";

const fileName = "CodeOfEthicsReport";
const exportType = "xls";
// let PageSize = 20;
const sliderRef = createRef();
const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 2000,
    infinite: false,
    centerMode: false,
    swipe: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};
const ReportTableCoe = (props) => {
    const {
        setSearchInput,
        getFilteredData,
        setIsLoading,
        isLoading,
        isView,
        statusFilterData,
        setCanShow,
        type,
        profileReports,
        // currentTableData,
        lpName,
        message,
        searchTable,
        isMobile,
    } = props;

    const dispatch = useDispatch();
    const profileReportRes = useSelector((state) => state.report.profileReport);
    const anyTotalReportRes = useSelector((state) => state.report.anyTotalReport);
    const authBroker = useSelector((state) => state.auth.authBroker)
    const authIframeBroker = useSelector(state => state.auth.authIframeBroker)
    // const [profileReports, setProfileReports] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const [legends, setLegends] = useState([]);
    const [series, setSeries] = useState([]);
    const [progressSort, setProgressSort] = useState('asc')
    const [searchinput, setSearchinput] = useState("");
    const [officeLabel, setOfficeLabel] = useState('')
    const [pageSize, setPageSize] = useState(50);

    const [isAllPageSelectedCheck, setIsAllPageSelectedCheck] = useState(false)
    const [allSelectedCount, setAllSelectedCount] = useState(0)


    const [allTableList,setAllTableList] = useState([])

    useEffect(() => {
		if (!_.isEmpty(authBroker)) {
			if (!_.isEmpty(authBroker.payload?.user?.config) && authBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authBroker])

  useEffect(() => {
		if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
			if (!_.isEmpty(authIframeBroker.payload?.user?.config) && authIframeBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authIframeBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Office Name')
			}
		}
	}, [authIframeBroker])

    useEffect(() => {
        setCurrentPage(1)
    }, [profileReports])

    const currentTableData = useMemo(() => {
        if (profileReports !== null) {
            let reportsData = _.clone(profileReports);
            reportsData = _.sortBy(reportsData, 'progress');
            if (progressSort === 'desc') {
                reportsData = _.reverse(reportsData)
            }
            const firstPageIndex = (currentPage - 1) * pageSize;
            const lastPageIndex = firstPageIndex + pageSize;
            setCanShow(true);
            setAllTableList(reportsData);
            return reportsData.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage, profileReports, progressSort,pageSize]);

    const ExportToExcel = () => {
        const data = _.cloneDeep(profileReports);
        for (let item of data) {
            item.status =
                item?.status === "In Progress"
                    ? "In Progress"
                    : item?.status === "NotStarted"
                        ? "Yet to start"
                        : "Completed";
            item.progress =
                item?.progress !== undefined && item?.progress !== ""
                    ? item?.progress + "%"
                    : "-";
            item.completion_date =
                item?.completion_date !== undefined && item?.completion_date !== ""
                    ? moment(
                        StaticUtils.getDateFromTimeStamp(item?.completion_date),
                        "MM/DD/YYYY"
                    ).format("DD MMM, YYYY")
                    : "-";
        }

        let tempArr = [];
        for (const item of data) {
            let obj = {
                "username": item.username,
                "email": item.email,
                "user_status": item.user_status ? 'Active' : 'In-Active',
                "office_name": item.office_name,
                "status": item.status,
                "progress": item.progress,
                "completion_date": item.completion_date,
            }
            tempArr.push(obj)
        }

        const newThing = [];
        tempArr.map((item) => {
            newThing.push(
                _.mapKeys(item, (value, key) => {
                    switch (key) {
                        case "username":
                            return "Name";
                        case "email":
                            return "Email";
                        case "user_status":
                            return "User Status";
                        case "office_name":
                            return {officeLabel};
                        case "status":
                            return "Status";
                        case "progress":
                            return "% Progress";
                        case "completion_date":
                            return "Date of Completion";
                        default:
                            return;
                    }
                })
            );
        });

        for (let i = 0; i < newThing.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete newThing[i].undefined;
        }

        for (let i = 0; i < data.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete data[i]._id;
        }
        // console.log('data:', data)
        // exportFromJSON({ data, fileName, exportType })

        //For mobile
        let tempObj = {
            method: "CodeOfEthicsReport",
            report: newThing
        }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(JSON.stringify(tempObj));
        } else if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(tempObj));
            }
        }

        const worksheet = XLSX.utils.json_to_sheet(newThing);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, fileName + ".xlsx");
    };


    const [selectedRemindUsers, setSelectedRemindUser] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [selectionPerPage, setSelectionPerPage] = useState(new Map());
    const [isAnyOneSelected,setIsAnyOneSelected] = useState(false)



    useEffect(() => {
        let tempMap = _.cloneDeep(selectionPerPage);
        let finalTemp = tempMap.set(currentPage, selectedRemindUsers);
        setSelectionPerPage(finalTemp)
        console.log("selectedPerPage2: ", tempMap, currentPage);
        let checkIsAllSelected = checkAllPagesSelected(finalTemp);
        setIsAllPageSelectedCheck(checkIsAllSelected)

    }, [selectedRemindUsers])

    const allPageSelectFunc = ()=>{
    
        let pages = 0;
        if(allTableList.length%pageSize===0){
          pages = allTableList.length/pageSize
        }else {
          pages = allTableList.length/pageSize+1;
        }
    
        let tempMap = new Map();
        for (let i = 0; i < pages; i++) {
          const firstPageIndex = (i - 1) * pageSize;
          const lastPageIndex = firstPageIndex + pageSize;
          let tableData = allTableList?.slice(firstPageIndex, lastPageIndex);
    
          let selectedUsers = clickAllSelectedUser(tableData,true);
          if (i === currentPage) {
            setSelectedRemindUser(selectedUsers)
        }
          tempMap.set(i, selectedUsers);
        }
        setSelectionPerPage(tempMap);
        
      }

      const checkAllPagesSelected = (selectionPerPage) => {
        let selectedCount = 0;
        for (let [key, value] of selectionPerPage) {
            selectedCount = selectedCount + value.length;
        }

        let itemCounts = 0;
        for (let i = 0; i < allTableList.length; i++) {
            const item = allTableList[i];
            if (item?.status?.toLowerCase() !== "completed") {
                itemCounts++;
            }
        }

        setAllSelectedCount(selectedCount)
        console.log('sleeccted: ', selectedCount, itemCounts)

        if(selectedCount ===0 && itemCounts === 0){
            return false
        }else{
        return selectedCount === itemCounts;}

    }
  
    


    useEffect(() => {
        let currSelection = selectionPerPage.get(currentPage);
        console.log("selectedPerPage1: ", selectionPerPage);
        if (currSelection === undefined) {
            setSelectedRemindUser([])
            setIsAllSelected(false)
        }
        else {
            setSelectedRemindUser(currSelection);
            if(currSelection.length===currentTableData.length){
                setIsAllSelected(true)
              }else{setIsAllSelected(false)}
        }
    }, [currentPage])

    useEffect(()=>{checkIfAnyOneSelected();},[selectionPerPage])

    const checkIfAnyOneSelected =()=>{
        let isSelected = false;
        let tempMap = _.cloneDeep(selectionPerPage);
        for (let [key, value] of tempMap) {
            console.log(key + " is " + value);
            if(value.length>0){
                isSelected=true;
                break;
            }
        }
        setIsAnyOneSelected(isSelected)
    }

    const clickAllSelectedUser = (currentTableData,isAllPageSelected=false) => {

        if (isAllSelected&&!isAllPageSelected) {
            setSelectedRemindUser([])
            setIsAllSelected(false);
        } else {
            let selectedArr = [];
            for (let index = 0; index < currentTableData.length; index++) {
                const item = currentTableData[index];
                if (item?.status?.toLowerCase() === "completed") {
                    continue;
                }
                let obj = {
                    user_id: item.uid,
                    entity_id: item.id,
                    entity_type: "coe",
                    status: item.status,
                    uniq_id: item.uid + item.id,
                };
                selectedArr.push(obj);
            }

            if(isAllPageSelected){
                return selectedArr;
              }else{        
            setSelectedRemindUser(selectedArr);
            setIsAllSelected(true);
              }
        }

    }


    const addRemindSelectedUser = (item, isRemove) => {
        if (item?.status?.toLowerCase() === "completed") {
            return;
        }
        console.log("inner:::::");
        if (isRemove) {
            let filteredArr = [];
            for (let i = 0; i < selectedRemindUsers.length; i++) {
                const element = selectedRemindUsers[i];
                if (element.uniq_id !== item.uid + item.id) {
                    filteredArr.push(element);
                }
            }
            setSelectedRemindUser(filteredArr);
            if (filteredArr.length < currentTableData.length) {
                setIsAllSelected(false)
            }
        } else {
            let obj = {
                user_id: item.uid,
                entity_id: item.id,
                entity_type: "coe",
                status: item.status,
                uniq_id: item.uid + item.id,
            };
            let selectedArr = _.cloneDeep(selectedRemindUsers);
            selectedArr.push(obj);
            setSelectedRemindUser(selectedArr);
            if (selectedArr.length === currentTableData.length) {
                setIsAllSelected(true)
            }
        }
    };
    const isExistId = (item) => {
        let isExist = false;
        for (let i = 0; i < selectedRemindUsers.length; i++) {
            const element = selectedRemindUsers[i];

            if (element.uniq_id === item.uid + item.id) {
                isExist = true;
                break;
            }
        }

        return isExist;
    };

    const resetAllSelection = ()=>{
        setIsAllSelected(false);
              setSelectionPerPage(new Map().set(0,[]))
              setSelectedRemindUser([])
      }
    
    const [confirmModal, setConfirmModal] = useState(false);
    const [showModalMsg, setShowModalMsg] = useState("");
    const remindSelectedUserReq = async () => {
        let selectedValues = [];
        for (let [key, value] of selectionPerPage) {
            console.log(key + " is " + value);
            selectedValues = [...selectedValues, ...value];
        } 
        setIsLoading(true);
        await axios({
            method: "post",
            url: `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.API_ROUTES_BROKER.REMIND_USER_REPORT_REQ}`,
            data: {
                token: isMobile
                    ? localStorage.getItem(SessionKeys.API_TOKEN)
                    : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                userdata: selectedValues,
            },
            header: { "Content-Type": "application/json" },
        })
            .then((response) => {
                console.log("RESPONSERemind", response);
                setIsLoading(false);
                if (response.data.status) {
                    setShowModalMsg(response.data.message);
                    resetAllSelection();
                } else {
                    setShowModalMsg("Error in sending reminder.");
                }
                let obj = { 'message': 'scrollToTop', }
                window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
                setConfirmModal(true);
                setIsLoading(false);
            })
            .catch((error) => {
                setConfirmModal(true);
                setShowModalMsg("Error in sending reminder.");
                setIsLoading(false);
            });
    };

    const renderTableReport = () => {
        return (
            <div className="row list-coach report-table-rsp">
                <div className="col-lg-12 col-md-12">
                    <div className="table-responsive1">
                        <div className="tablebox">
                            <table className="table mb-0 office_list table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            <div
                                                className="form-check cursor-pointer position-relative ps-0 pt-1"
                                                onClick={() => {
                                                    clickAllSelectedUser(currentTableData)
                                                }}
                                            >
                                                <input
                                                    className="form-check-input cursor-pointer"
                                                    type="checkbox"
                                                    checked={isAllSelected || isAllPageSelectedCheck}
                                                />
                                                <label
                                                    className="form-check-label cursor-pointer"
                                                    for="termofusein"
                                                ></label>
                                            </div>
                                        </th>
                                        <th className="office-province">Name</th>
                                        <th className="office-province">Role</th>
                                        <th className="office-province">Email</th>
                                        <th className="office-province">User Status</th>
                                        <th className="office-province">{officeLabel}</th>
                                        <th className="office-province">Manager</th>
                                        <th className="office-province dateboxhead">
                                            Date of Completion
                                        </th>
                                        <th className="office-province">Status</th>
                                        <th className={`office-province sortingtable cursor-pointer text-center
                    ${progressSort === 'asc' ? '' : 'decend'}`}
                                            onClick={() => {
                                                resetAllSelection();
                                                setProgressSort(progressSort === 'asc' ? 'desc' : 'asc')
                                            }
                                            }
                                        >% Progress</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentTableData?.map((item, index) => {
                                        return (
                                            <tr className="addBGcustomw">
                                                <td>
                                                    <div
                                                        className={`form-check position-relative ps-0 pt-1 ${(item?.status?.toLowerCase() === "completed") ? "opacity-half" : 'cursor-pointer'}`}
                                                        onClick={() => {
                                                            if (item?.status?.toLowerCase() === "completed") {
                                                                return;
                                                            }
                                                            if (isExistId(item)) {
                                                                addRemindSelectedUser(item, true);
                                                            } else {
                                                                addRemindSelectedUser(item, false);
                                                            }
                                                        }}
                                                    >
                                                        <input
                                                            className="form-check-input cursor-pointer"
                                                            type="checkbox"
                                                            checked={isExistId(item)}
                                                        />
                                                        <label
                                                            className="form-check-label cursor-pointer"
                                                            for="termofusein"
                                                        ></label>
                                                    </div>
                                                </td>
                                                <td>{item?.username}</td>
                                                <td>{item?.role}</td>
                                                <td>{item?.email}</td>
                                                <td>{item?.user_status ? 'Active' : 'In-Active'}</td>
                                                <td>{item?.office_name}</td>
                                                {item?.manager === "No name found" ? <td className="text-center">-</td> : <td> {item?.manager}</td>}
                                                <td className="text-center dateoe">
                                                    <strong>
                                                        {item?.completion_date !== undefined &&
                                                            item?.completion_date !== ""
                                                            ? moment(
                                                                StaticUtils.getDateFromTimeStamp(
                                                                    item?.completion_date
                                                                ),
                                                                "MM/DD/YYYY"
                                                            ).format("DD MMM, YYYY")
                                                            : "-"}
                                                    </strong>
                                                </td>
                                                <td className={item?.status === "In Progress"
                                                    ? "inprogress-sta status-rp"
                                                    : item?.status === "NotStarted"
                                                        ? "start-sta-nonod status-rp"
                                                        : "completed-sta status-rp"}
                                                >
                                                    {/* <span className="complte">
                                                        <img
                                                            src={
                                                                item?.status === "In Progress"
                                                                    ? "/images/inprogress.svg"
                                                                    : item?.status === "NotStarted"
                                                                        ? "/images/yet-to-start-svg.svg"
                                                                        : "/images/check-report.svg"
                                                            }
                                                            width="18"
                                                            height="18"
                                                        />
                                                    </span> */}
                                                    <strong>
                                                        {item?.status === "In Progress"
                                                            ? "In Progress"
                                                            : item?.status === "NotStarted"
                                                                ? "Yet to start"
                                                                : "Completed"}
                                                    </strong>
                                                </td>
                                                <td className="text-center percoe">
                                                    <strong>
                                                        {item?.progress !== undefined &&
                                                            item?.progress !== "" &&
                                                            item?.progress !== null
                                                            ? item?.progress + "%"
                                                            : "-"}
                                                    </strong>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* <PaginationProgress
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={profileReports?.length}
              pageSize={pageSize}
              onPageChange={(page) => {
                window.scroll({
                  top: 100,
                  left: 0,
                  behavior: "smooth",
                });
                setCurrentPage(page);
              }}
            /> */}
            <div className="pagetab d-flex justify-content-center gap-2 mt-5 align-items-center">
              <div className="input-lear">
                <select
                  className="form-select mb-0"
                  onChange={(evt) => {
                    setCurrentPage(1);
                    setPageSize(_.toNumber(evt.target.value));
                    resetAllSelection();
                  }}
                >
                  <option selected={pageSize===20} value="20">20</option>
                  <option selected={pageSize===50} value="50">50</option>
                  <option selected={pageSize===100} value="100">100</option>
                </select>
              </div>
              <span className="rosetext">rows per page</span>
                        <PaginationProgress
                            className="pagination-bar m-0"
                            currentPage={currentPage}
                            totalCount={profileReports?.length}
                            pageSize={pageSize}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderGraphReport = () => {
        return (
            <ReportGraphSection
                series={series}
                legends={legends}
                isLoading={isLoading}
                type={type}
                isAmount={false}
            />
        );
    };



    return (
        <>
            <section className="table-report-layout mt-rem">
                {true ? (
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-head">
                                    Details
                                </div>
                            </div>


                            <div className="d-flex justify-content-between align-items-center col-md-12 search__input mb-4 flex-wrap gap-3">
                                <div className="input-lear position-relative d-flex">
                                    <label htmlFor="search" className="input__label_learning">Search</label>
                                    <input type="search" id="search" name="search" className="input_searchfield_search mb-0"
                                        autocomplete="off" onChange={(evt) => {
                                            if (!evt.target.value) searchTable('')
                                            // searchTable(evt.target.value)
                                            setSearchinput(evt.target.value)
                                        }} />
                                    <button className="button-reset" onClick={() => { searchTable(searchinput) }} >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            id="Find"
                                            width="28"
                                            height="28"
                                            viewBox="0 0 30 30"
                                        >
                                            <defs>
                                                <linearGradient
                                                    id="linear-gradient"
                                                    y1="0.5"
                                                    x2="1"
                                                    y2="0.5"
                                                    gradientUnits="objectBoundingBox"
                                                >
                                                    <stop offset="0" stopColor="#00b7f1" />
                                                    <stop offset="1" stopColor="#ed156e" />
                                                </linearGradient>
                                            </defs>
                                            <circle
                                                id="Ellipse_191"
                                                data-name="Ellipse 191"
                                                cx="15"
                                                cy="15"
                                                r="15"
                                                fill="url(#linear-gradient)"
                                            />
                                            <circle
                                                id="Ellipse_192"
                                                data-name="Ellipse 192"
                                                cx="13"
                                                cy="13"
                                                r="13"
                                                transform="translate(2 2)"
                                                fill="#fff"
                                            />
                                            <path
                                                id="Icon_awesome-search"
                                                data-name="Icon awesome-search"
                                                d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z"
                                                transform="translate(7.715 7.714)"
                                                fill="#774d9f"
                                            />
                                        </svg>
                                    </button>
                                </div>

                            <div className="d-flex gap-2 align-items-center">
                                    <div className="select-all-option table-responsive1">
                                        <div className="form-check cursor-pointer position-relative p-0 m-0 d-flex align-items-center"
                                            onClick={() => {
                                                if (isAllPageSelectedCheck) {
                                                    resetAllSelection()
                                                } else {
                                                    allPageSelectFunc();
                                                }

                                            }}>
                                            <input className="form-check-input cursor-pointer" type="checkbox" checked={isAllPageSelectedCheck} />
                                            <label className="form-check-label cursor-pointer" for="selectall"></label>
                                        </div>
                                        <label className="fromd">Select All</label>
                                    </div>
                                <div className="input-lear">
                                    <button
                                        className="btn btn-primary-complete bckbtn"
                                        onClick={() => {
                                            console.log("selectedUsers: ", selectedRemindUsers)
                                            remindSelectedUserReq();
                                        }}
                                        disabled={!isAnyOneSelected}
                                    >
                                        Remind Selected Users
                                    </button>
                                </div>
                            </div>    
                            </div>
                            {isAllPageSelectedCheck ? <div className="col-md-12">
                                <div className="textskected">
                                    All <b>{allSelectedCount}</b> Agents are selected.
                                </div>
                            </div> : (isAllSelected) ? <div className="col-md-12">
                                <div className="textskected">
                                    All <b>{selectedRemindUsers?.length}</b> Agents on this page are selected.
                                </div>
                            </div> : ""}
                        </div>
                        {currentTableData && currentTableData?.length > 0 ? (
                            renderTableReport()
                        ) : profileReports !== null ? (
                            <div className="not-found mt-3">
                                <div className=" interboxes">
                                    <img src="/images/telescope.svg" alt="Not Found" />
                                    <p>{message}</p>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ) : (
                    ""
                )}
            </section>
            <SimplePopup
                confirmModal={confirmModal}
                setConfirmModal={setConfirmModal}
                showModalMsg={showModalMsg}
                isRightIcon={true}
                isMobile={isMobile}
            />
        </>
    );
};
export default ReportTableCoe;
